'use client'

import { useContext, useEffect, useState } from "react";
import FloatDialog from "./_floatDialog";
import { LiveStreamContext } from "@/app/livebroadcast/_config";
import { DeviceContext } from "@/context/deviceContext";
import { SportsLiveListType } from "@/type/list";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useTranslations } from "next-intl";

export default function FloatMultiViewSelect({ show, setShow }: { show: boolean, setShow: Function }) {
    const { mobileMode } = useContext(DeviceContext)
    const {
        stream_1,
        stream_2,
        stream_3,
        stream_4,
        DelViewUrl,
        AddViewUrl,
        streamLen,
        setMultiSelectShow,
        recentUrl,
        set_recentUrl
    } = useContext(LiveStreamContext)

    const t = useTranslations("Text")

    function selectView(index: number) {
        if (recentUrl) {
            AddViewUrl(recentUrl, index)
        }
        setMultiSelectShow(false)
    }
    const [viewUrls, setViewUrls] = useState<any[]>([])

    useEffect(() => {
        setViewUrls([stream_1, stream_2, stream_3, stream_4])
    }, [stream_1, stream_2, stream_3, stream_4])

    return (
        <FloatDialog
            show={show}
            setShow={setShow}
            onHide={() => { set_recentUrl(undefined) }}
            className="multi-view"
        >
            <FloatDialog.Head>{t("스크린 선택")}</FloatDialog.Head>
            <FloatDialog.Body>
                <div className="select-view">
                    {
                        viewUrls.map((playVideo, index) => {
                            const screenNum = index + 1

                            if (streamLen != 1 && screenNum > streamLen) {
                                return null;
                            } else if (mobileMode && index > 2) {
                                return null;
                            } else {

                                return (
                                    <div key={index} className={playVideo ? "hold" : ""}>
                                        {
                                            playVideo
                                            && <SelectedStream li={viewUrls[index]} />
                                        }
                                        {
                                            playVideo
                                            && <span className="close-btn" onClick={e => DelViewUrl(screenNum)}>
                                                <FontAwesomeIcon icon={faXmark} />
                                            </span>
                                        }
                                        <div className="site-info" onClick={e => selectView(screenNum)}>
                                            <p>{t("스크린")} {screenNum}</p>
                                            <span className="add"></span>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </FloatDialog.Body>
        </FloatDialog>
    )
}

function SelectedStream({ li }: { li: SportsLiveListType }) {
    return (
        <div className="multi-selected-stream">
            <div className="thumnail">
                {
                    li.leagueName != 'HD'
                        ? <img src={li.thumbnail} alt={li.thumbnail} />
                        : <div className="empty-thumnail">{li.home_name}</div>
                }
            </div>
            <div className="info">
                <div className="league">{li.leagueName}</div>
                <div className="date">{li.leagueName != 'HD' ? li.date : "LIVE HD"}</div>
                <div className="vs">
                    <p><span className="ha home"></span>{li.home_name}</p>
                    <p><span className="ha away"></span>{li.away_name}</p>
                </div>
            </div>
        </div>
    )
}